let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6jN77")).then(() => parcelRequire('4Wmwb'));